import { PrimitiveClasses_getInstance143761yrsca9q as PrimitiveClasses_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  equals2au1ep9vhcato as equals,
  captureStack1fzi4aczwc4hg as captureStack,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { atomic$boolean$1iggki4z65a2h as atomic$boolean$1 } from '../../../../../kotlinx-atomicfu/kotlinx/atomicfu/AtomicFU.mjs';
import { throwUninitializedPropertyAccessException14fok093f3k3t as throwUninitializedPropertyAccessException } from '../../../../../kotlin-kotlin-stdlib/kotlin/internal/ThrowHelpers.mjs';
import { DefaultHttpRequest19v463zllbymg as DefaultHttpRequest } from '../request/DefaultHttpRequest.mjs';
import { DefaultHttpResponse2wnrinzo0twhn as DefaultHttpResponse } from '../statement/DefaultHttpResponse.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ByteReadChannel2wzou76jce72d as ByteReadChannel } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannel.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { instanceOf2cx3k00nj6a0p as instanceOf } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/TypeInfo.web.mjs';
import { get_isSaved1yor47kvbhumv as get_isSaved } from '../plugins/SaveBody.mjs';
import { HttpResponseContainer3r9yzy4mwwvc9 as HttpResponseContainer } from '../statement/HttpResponsePipeline.mjs';
import { NullBody_instanceyfq32eqie90j as NullBody_instance } from '../../../../../ktor-ktor-http/io/ktor/http/content/OutgoingContent.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { cancel2ztysw4v4hav6 as cancel } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { get_request3dwcif5y0fvf1 as get_request } from '../statement/HttpResponse.mjs';
import { trimIndent1qytc1wvt8suh as trimIndent } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Indent.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        // Inline function 'io.ktor.util.AttributeKey' call
        var name = 'CustomResponse';
        // Inline function 'io.ktor.util.reflect.typeInfo' call
        var tmp_0 = PrimitiveClasses_getInstance().rf();
        // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
        var tmp_1;
        try {
          tmp_1 = createKType(PrimitiveClasses_getInstance().rf(), arrayOf([]), false);
        } catch ($p) {
          var tmp_2;
          if ($p instanceof Error) {
            var _unused_var__etf5q3 = $p;
            tmp_2 = null;
          } else {
            throw $p;
          }
          tmp_1 = tmp_2;
        }
        var tmp$ret$2 = tmp_1;
        var tmp$ret$1 = new (TypeInfo())(tmp_0, tmp$ret$2);
        tmp.j5j_1 = new (AttributeKey())(name, tmp$ret$1);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var HttpClientCallClass;
function HttpClientCall() {
  if (HttpClientCallClass === VOID) {
    class $ {
      constructor(client) {
        return new.target.o5i(client);
      }
      static o5i(client) {
        Companion_getInstance();
        var $this = createThis(this);
        $this.m5g_1 = client;
        $this.n5g_1 = atomic$boolean$1(false);
        $this.q5g_1 = false;
        return $this;
      }
      bw() {
        return this.r5g().bw();
      }
      q5i() {
        return this.p5i().q5i();
      }
      p5i() {
        var tmp = this.o5g_1;
        if (!(tmp == null))
          return tmp;
        else {
          throwUninitializedPropertyAccessException('request');
        }
      }
      r5g() {
        var tmp = this.p5g_1;
        if (!(tmp == null))
          return tmp;
        else {
          throwUninitializedPropertyAccessException('response');
        }
      }
      static k5j(client, requestData, responseData) {
        Companion_getInstance();
        var $this = this.o5i(client);
        $this.o5g_1 = new (DefaultHttpRequest())($this, requestData);
        $this.p5g_1 = new (DefaultHttpResponse())($this, responseData);
        $this.q5i().n4n(Companion_getInstance().j5j_1);
        var tmp = responseData.p5j_1;
        if (!isInterface(tmp, ByteReadChannel())) {
          $this.q5i().l4n(Companion_getInstance().j5j_1, responseData.p5j_1);
        }
        return $this;
      }
      r5i() {
        return this.q5g_1;
      }
      *s5i($completion) {
        return this.r5g().e5j();
      }
      *t5i(info, $completion) {
        try {
          if (instanceOf(this.r5g(), info.o4t_1))
            return this.r5g();
          if (!this.r5i() && !get_isSaved(this.r5g()) && !this.n5g_1.atomicfu$compareAndSet(false, true)) {
            throw DoubleReceiveException().x5j(this);
          }
          var tmp0_elvis_lhs = this.q5i().j4n(Companion_getInstance().j5j_1);
          var responseData = tmp0_elvis_lhs == null ? (yield* this.s5i($completion)) : tmp0_elvis_lhs;
          var subject = new (HttpResponseContainer())(info, responseData);
          // Inline function 'kotlin.takeIf' call
          var this_0 = (yield* this.m5g_1.f5g_1.v4s(this, subject, $completion)).z5j_1;
          var tmp;
          if (!equals(this_0, NullBody_instance)) {
            tmp = this_0;
          } else {
            tmp = null;
          }
          var result = tmp;
          if (!(result == null) && !instanceOf(result, info.o4t_1)) {
            var from = getKClassFromExpression(result);
            var to = info.o4t_1;
            throw NoTransformationFoundException().f5k(this.r5g(), from, to);
          }
          return result;
        } catch ($p) {
          if ($p instanceof Error) {
            var cause = $p;
            cancel(this.r5g(), 'Receive failed', cause);
            throw cause;
          } else {
            throw $p;
          }
        }
      }
      toString() {
        return 'HttpClientCall[' + this.p5i().y5i().toString() + ', ' + this.r5g().f5j().toString() + ']';
      }
      s5g(response) {
        this.p5g_1 = response;
      }
    }
    initMetadataForClass($, 'HttpClientCall', VOID, VOID, VOID, [0, 1]);
    HttpClientCallClass = $;
  }
  return HttpClientCallClass;
}
var DoubleReceiveExceptionClass;
function DoubleReceiveException() {
  if (DoubleReceiveExceptionClass === VOID) {
    class $ extends IllegalStateException() {
      constructor(call) {
        return new.target.x5j(call);
      }
      static x5j(call) {
        var $this = this.m();
        captureStack($this, $this.w5j_1);
        $this.v5j_1 = 'Response already received: ' + call.toString();
        delete $this.message;
        return $this;
      }
      r() {
        return this.v5j_1;
      }
      get message() {
        return this.r();
      }
    }
    initMetadataForClass($, 'DoubleReceiveException');
    DoubleReceiveExceptionClass = $;
  }
  return DoubleReceiveExceptionClass;
}
var NoTransformationFoundExceptionClass;
function NoTransformationFoundException() {
  if (NoTransformationFoundExceptionClass === VOID) {
    class $ extends UnsupportedOperationException() {
      constructor(response, from, to) {
        return new.target.f5k(response, from, to);
      }
      static f5k(response, from, to) {
        var $this = this.j8();
        captureStack($this, $this.e5k_1);
        $this.d5k_1 = trimIndent("\n        Expected response body of the type '" + toString(to) + "' but was '" + toString(from) + "'\n        In response from `" + get_request(response).y5i().toString() + '`\n        Response status `' + response.f5j().toString() + '`\n        Response header `ContentType: ' + response.w51().c2o('Content-Type') + '` \n        Request header `Accept: ' + get_request(response).w51().c2o('Accept') + '`\n        \n        You can read how to resolve NoTransformationFoundException at FAQ: \n        https://ktor.io/docs/faq.html#no-transformation-found-exception\n    ');
        delete $this.message;
        return $this;
      }
      r() {
        return this.d5k_1;
      }
      get message() {
        return this.r();
      }
    }
    initMetadataForClass($, 'NoTransformationFoundException');
    NoTransformationFoundExceptionClass = $;
  }
  return NoTransformationFoundExceptionClass;
}
//region block: exports
export {
  HttpClientCall as HttpClientCall2j6myj8ctykar,
};
//endregion

//# sourceMappingURL=HttpClientCall.mjs.map
